// vant 国际化
import moment from 'moment';

function changeLang(newlang) {
  switch (newlang) {
    case 'tl-PH':
      moment.locale('tl-ph');
      break;
    default:
      moment.locale('en');
      break;
  }
}
 
export function Local(mylang) {
  changeLang(mylang)
}